"use client"

import {useEffect, useState} from 'react';
import {useAppStore} from "@/store/AppStore";
import {Liturgies} from "@/types/Liturgies";
import {liturgiesRequest} from "@/utils/api/Liturgies";
import {useLocale} from "use-intl";

const useLiturgiesData = (token?: string) => {
  const locale = useLocale()
  const [data, setData] = useState<Liturgies | undefined>(undefined)
  const setRefresh = useAppStore((state) => state.setRefresh);

  useEffect(() => {
    const fetchData = async (token: string) => {
      const fetched = await liturgiesRequest(token, locale)
      if (false === fetched) {
        setRefresh(true)
        return true
      }
      if (fetched) {
        setData(fetched)
      }
    }
    if (!data && token) {
      fetchData(token)
    }
  }, [setRefresh, token, data, locale]);

  return data
};

export default useLiturgiesData;
